<template>
  <div class="page-content schedule">
    <h1 class="page-title">{{ $locale("sideMenu.performance.schedule") }}</h1>

    <el-row class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button
          :class="notApprove > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
          :disabled="notApprove > 0 ? false : true"
          @click="approve_fn('date')"
          >{{ $locale("global.dateApprove") }}</el-button
        >
        <el-button
          class="egl-btn-yellow"
          @click="approve_fn('all')"
          >{{ $locale("global.allApprove") }}</el-button
        >
        <!-- <el-button
          :class="notApprove > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
          :disabled="notApprove > 0 ? false : true"
          >{{ $locale("global.dateApprove") }}</el-button
        >
        <el-button
          :class="notApprove > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
          :disabled="notApprove > 0 ? false : true"
          @click="approve_fn"
          >{{ $locale("global.allApprove") }}</el-button
        > -->
        <el-button class="egl-btn-yellow" @click="toCreate">{{
          $locale("global.create")
        }}</el-button>
        <el-button class="egl-btn-yellow" @click="$refs.linkageCsvDialog.showDialog()">
          {{ $locale("schedule.linkageCsvExport") }}
        </el-button>
      </el-col>
    </el-row>

    <ScheduleTab
      ref="scheduleTab"
      v-bind:targetDay.sync="searchDay"
      v-bind:actBtn="dateType"
      @handleFn="getTabAction"
    ></ScheduleTab>
    <FlowList
      v-if="dateType == 'DAYS'"
      v-bind:filmList="filmList"
      v-bind:versionList="versionList"
      v-bind:otherVersionList="otherVersionList"
      v-bind:houseList="houseList"
      v-bind:scheduleList.sync="scheduleList"
      v-bind:showHandle="true"
      @handleFn="getFlowSearch"
      @showSoldSeat="showSoldSeat"
      @getScheduleList="getData"
      @resetIds="deleteScheduleIds = []"
      :deleteIds="deleteScheduleIds"
    ></FlowList>
    <CalenderBox
      v-if="dateType == 'WEEKLY'"
      v-bind:targetDay="searchDay"
      v-bind:filmList="filmList"
      v-bind:scheduleList.sync="scheduleList"
      v-bind:showHandle="true"
      @handleFn="getCalenderSearch"
      @showSoldSeat="showSoldSeat"
    ></CalenderBox>

    <SoldSeatDialog ref="soldSeat"></SoldSeatDialog>
    <LinkageCsvDialog ref="linkageCsvDialog"></LinkageCsvDialog>
  </div>
</template>

<script>
import ScheduleTab from "@/components/Schedule/ScheduleTab.vue";
import FlowList from "@/components/Schedule/FlowList.vue";
import CalenderBox from "@/components/Schedule/CalendarBox.vue";
import SoldSeatDialog from "@/components/Schedule/SoldSeatDialog.vue";
import LinkageCsvDialog from "@/components/Schedule/LinkageCsvDialog.vue";
import {
  getShceduleList_fn,
  getMovieListMap,
  getVersion_fn,
  getOtherVersion_fn,
  getHouse,
  getHouseOptions
} from "@/assets/js/schedule.js";
import { approveSchedule } from "@/helpers/service/api/schedule.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import "@/assets/style/schedule.less";
import { mapState } from 'vuex'

export default {
  name: "Schedule",
  provide() {
    return {
      setSelected: this.setSelectedSchedule,
      setGroupSelected: this.setGroupSelected,
      setAllSelected: this.setAllSchedule,
      totalSelected: () => this.totalSelected
    }
  },
  data() {
    return {
      // dateType: "WEEKLY", // DAYS|WEEKLY
      dateType: "DAYS",
      searchDay: "",
      filmIds: [],
      versions: [],
      subtitlesVersions: [],
      otherVersions: [],
      houseIds: [],
      freeSeat: null,

      scheduleList: [],
      filmList: [],
      versionList: [],
      otherVersionList: [],
      houseList: [],

      notApprove: 0,
      deleteScheduleIds: [],
    };
  },
  methods: {
    toCreate() {
      let link = "/schedule/create";

      this.$router.push({ path: link });
    },
    getTabAction(obj) {
      let params = {};

      if (obj.value == "DAYS") {
        params.filmIds = [ ...this.filmIds ];
        params.versions = [ ...this.versions ];
        params.subtitlesVersions = [ ...this.subtitlesVersions ];
        params.otherVersions = [ ...this.otherVersions ];
        params.houseIds = [ ...this.houseIds ];
      }

      if (obj.type == "list") {
        let newDateType = obj.value;

        if (newDateType != this.dateType) {
          params.dateType = newDateType;
          params.date = this.searchDay;

          this.getData(params);
        }
      }

      if (obj.type == "date") {
        let date = obj.value;

        if (date != this.searchDay) {
          params.date = date;
          params.dateType = this.dateType;
          this.getData(params);
        }
      }
    },
    getFlowSearch(obj) {
      let params = JSON.parse(JSON.stringify(obj));
      params.dateType = this.dateType;
      params.date = this.searchDay;

      this.filmIds = params.filmIds;
      this.versions = params.versions;
      this.subtitlesVersions = params.subtitlesVersions;
      this.otherVersions = params.otherVersions;
      this.houseIds = params.houseIds;
      this.freeSeat = params.freeSeat;
      
      
      this.getData(params);
    },
    getCalenderSearch(day) {
      let params = {
        dateType: "WEEKLY",
        date: day
      };

      this.getData(params);
    },
    getData(obj = {}) {
      const that = this;
      let cinemaId = window.localStorage.getItem("cinemaId") || "";
      let params = { ...obj, cinemaId };
      let paramsText = "";

      if (cinemaId == "") {
        that.$emit("callCinema", "getData");

        return;
      }

      if (!obj.dateType) {
        params.dateType = this.dateType;
        params.date = this.searchDay;
      }

      Object.keys(params).map(keyName => {
        if (params[keyName]) {
          if (typeof params[keyName] === "string") {
            paramsText = paramsText + "&" + keyName + "=" + (keyName === "date" ? this.$moment(params[keyName]).valueOf() : params[keyName]);
          } else if (params[keyName].length > 0) {
            paramsText =
              paramsText +
              "&" +
              keyName +
              "=" +
              (keyName === "date" ? this.$moment(params[keyName].toString().replace(/,/g, "&" + keyName + "=")) : params[keyName].toString().replace(/,/g, "&" + keyName + "="));
          }
        }
      });
      // paramsText = paramsText.substring(1, paramsText.length);

      requestAll([
        getShceduleList_fn(paramsText),
        getMovieListMap(cinemaId),
        getVersion_fn(cinemaId),
        getOtherVersion_fn(cinemaId),
        getHouseOptions(cinemaId)
      ])
        .then(res => {
          let notApprove = 0;

          // for (let i = 0; i < res[0].data.length; i++) {
          //   if (!res[0].data[i].approve) {
          //     notApprove = 1;
          //     break;
          //   }
          // }
          const scheduleStatus = res[0].data.find(item => item.scheduleStatus === "pending");
          if (scheduleStatus) { notApprove = 1; }

          that.searchDay = params.date;
          if (this.searchDay === this.$moment().format("YYYY-MM-DD")) {
            this.$refs["scheduleTab"].date = this.searchDay;
          }
          that.scheduleList = this.$_.sortBy(res[0].data, "showStartTime");
          that.filmList = res[1].data.data;
          that.versionList = res[2].data.data;
          that.otherVersionList = res[3].data.data;
          that.houseList = res[4].data;
          that.notApprove = notApprove;
          that.dateType = params.dateType;

          if (params.dateType == "WEEKLY") {
            that.filmIds = [];
            that.versions = [];
            that.subtitlesVersions = [];
            that.otherVersions = [];
            that.houseIds = [];
          }

          this.scheduleList.forEach(_sl => {
            const targetVersion = this.versionList.find(_VL => _VL.id === _sl.filmVersion) || {};
            _sl.versionName = targetVersion.name;
            _sl.isChecked = false
            this.deleteScheduleIds.forEach((id) => {
              if (id === _sl.scheduleId) {
                _sl.isChecked = true;
              }
            })
          });
        });
    },
    approve_fn(type) {
      let obj = { cinemaId: window.localStorage.getItem("cinemaId") };
      if (type !== "all") {
        obj.date = this.searchDay;
      }
      if (type === "all" || this.notApprove > 0) {
        let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

        this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.approve"),
          customClass: "egl-confirm",
          closeOnClickModal: false
        })
          .then(() => {
            // let cinemaId = window.localStorage.getItem("cinemaId") || "";
            approveSchedule(obj)
              .then(res => {
                if (res.success) {
                  countDownAlert({
                    content: this.$locale("global.approveSuccessful"),
                    callback: () => {
                      let params = {};

                      params.dateType = this.dateType;
                      params.date = this.searchDay;

                      if (params.dateType == "DAYS") {
                        params.filmIds = [ ...this.filmIds ];
                        params.versions = [ ...this.versions ];
                        params.subtitlesVersions = [ ...this.subtitlesVersions ];
                        params.otherVersions = [ ...this.otherVersions ];
                        params.houseIds = [ ...this.houseIds ];
                      }

                      this.getData(params);
                    }
                  });

                } else {
                  this.$alert(res.message, {
                    showClose: false
                  });
                }
              })
              .catch(() => {});
          });
      }
    },
    showSoldSeat(scheduleId, movieId) {
      this.$refs.soldSeat.showDialog(scheduleId, movieId);
    },
    delete_fn(type) {
      const msgMapping = {
        all: "全ての未承認スケジュールを削除しますが、よろしいですか？",
        day: "現在表示されている日付の未承認スケジュールを削除しますが、よろしいですか？"
      };
      let obj = { cinemaId: window.localStorage.getItem("cinemaId") };
      if (type !== "all") {
        obj.date = this.searchDay;
      }
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${msgMapping[type]}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        deleteSchedulesService(obj).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                let params = {};
                params.dateType = this.dateType;
                params.date = this.searchDay;
                if (params.dateType == "DAYS") {
                  params.filmIds = [ ...this.filmIds ];
                  params.versions = [ ...this.versions ];
                  params.subtitlesVersions = [ ...this.subtitlesVersions ];
                  params.otherVersions = [ ...this.otherVersions ];
                  params.houseIds = [ ...this.houseIds ];
                  this.getData(params);
                }
              }
            });
          }
        });
      });


    },
    setGroupSelected(isChecked, type, id) {
      let _scheduleList = this.$_.cloneDeep(this.scheduleList)
      const typeMapping = {
        film: "filmId",
        screen: "houseName",
        subtitles: "NONE",
      }
      _scheduleList.forEach(item => {
        if (item[typeMapping[type]] === id) {
          item.isChecked = isChecked
          if (isChecked) {
            this.deleteScheduleIds.push(item.scheduleId);
            this.deleteScheduleIds = this.$_.uniq(this.deleteScheduleIds);
            // _this.deleteScheduleIds = new Set(this.deleteScheduleIds);
          } else {
            const index = this.deleteScheduleIds.findIndex((id) => id === item.scheduleId);
            this.deleteScheduleIds.splice(index, 1);
          }
        }
      })
      this.scheduleList = _scheduleList
    },
    setSelectedSchedule(isChecked, scheduleId) {
      let _scheduleList = this.$_.cloneDeep(this.scheduleList)
      const idx = _scheduleList.findIndex(item => item.scheduleId === scheduleId);
      _scheduleList[idx].isChecked = isChecked
      this.scheduleList = _scheduleList

      // save scheduleId to ids
      if (isChecked) {
        this.deleteScheduleIds.push(scheduleId)
      } else {
        const index = this.deleteScheduleIds.findIndex((id) => id === scheduleId);
        this.deleteScheduleIds.splice(index, 1);
      }
    },
    setAllSchedule(isAll) {
      let _scheduleList = this.$_.cloneDeep(this.scheduleList)
      _scheduleList.forEach(item => {
        item.isChecked = isAll
        if (isAll) {
          this.deleteScheduleIds.push(item.scheduleId);
          this.deleteScheduleIds = this.$_.uniq(this.deleteScheduleIds);
          // _this.deleteScheduleIds = new Set(this.deleteScheduleIds);
        } else {
          // this.$_.remove(this.deleteScheduleIds, function(id) {
          //   return id === item.scheduleId;
          // })
          const index = this.deleteScheduleIds.findIndex((id) => id === item.scheduleId);
          this.deleteScheduleIds.splice(index, 1);
        }

      })
      this.scheduleList = _scheduleList
    }
  },
  computed: {
    ...mapState("schedule", {
      updateTime: state => state.updateTime
    }),
    totalSelected() {
      // return this.scheduleList.filter(item => item.isChecked).length;
      return this.deleteScheduleIds.length;
    },
  },
  mounted() {
    this.cinemaId = window.localStorage.getItem('cinemaId');
    const today = this.$moment(this.updateTime).format("YYYY-MM-DD");

    this.searchDay = today;

    this.getData({
      dateType: this.dateType,
      date: today
    });
  },
  components: {
    ScheduleTab,
    FlowList,
    CalenderBox,
    SoldSeatDialog,
    LinkageCsvDialog,
  }
};
</script>
